<template>
  <footer>
    <div class="newsletter-box">
            
          <div class="text text-wide">

              <h3>Bleib in Verbindung</h3>
                <p>Damit du nichts mehr verpasst, melde dich zum 
                  <router-link :to="{ path: '/newsletter' }" class="link"> <img src="../assets/img/news-icon.svg" width="30px"> Newsletter</router-link>
                  an.</p>
                  <p>Außerdem gibts regelmäßige Infos auf <img src="../assets/img/facebook.svg" width="30px">
                          <a href="https://www.facebook.com/pferdeverstand.at">Facebook</a> und <img src="../assets/img/insta.svg" width="30px"> <a href="https://www.instagram.com/pferdeverstand.at/">Instagram</a>.</p>
    </div>
  </div>
    <div class="grey-box">
      <div class="flex-group align-end">
        <!-- <div class="content-container"> -->
          <div class="text">
            <h2 class="sr-only">Kontakt</h2>
            <p>
              <b>Pferdeverstand.at</b><br />
              Sabine D&ouml;br&ouml;ssy BSc<br />
              Pielachstraße 6<br />
              AT - 3382 Albrechtsberg an der Pielach
            </p>
            <p>Email: <a href="mailto:info@pferdeverstand.at?subject=Anfrage%20Pferdeverstand.at">info@pferdeverstand.at</a></p>
            <p>Mobil: <a href="tel:+436503614224">0650 / 36 14 224</a></p>
            

            <!-- TODO: float, no padding left -->
            <p><router-link :to="{ path: '/impressum' }" class="link">Impressum</router-link><br></p>
              <!-- <ul class="footer-list">
                <li><router-link :to="{ path: '/agb' }" class="link">AGB</router-link></li>
                <li><router-link :to="{ path: '/impressum' }" class="link">Impressum</router-link></li>
              </ul>-->
            </div> 
            
            <div class="logo-block">
              <img src="../assets/img/home/logo-short.png" alt="">
              <p class="invert">... für alle, die mit ihrem Pferd weiterkommen wollen.</p>
            </div>  
        </div>
      <!-- </div> -->


    </div>
  </footer>
</template>

<script>

export default {
  name: "Footer"
};
</script>




// WEBPACK FOOTER //
// src/components/Footer.vue